import { Image } from '@/components/common/Image';
import { TEACHER_STATS } from '../data';

export function TeacherSection() {
  return (
    <section className="bg-white">
      <div className="mx-auto w-full max-w-[1144px] px-6 pt-10 pb-20 sm:px-12 sm:pt-12 sm:pb-24">
        <p className="text-xs font-semibold uppercase tracking-[0.18em] text-brand-600 sm:text-sm">
          Meet Your Instructor
        </p>

        <h2 className="mt-5 text-3xl font-semibold leading-[1.1] tracking-tight text-slate-900 sm:text-4xl lg:text-5xl">
          Taught by Abraham &mdash; the same
          <br className="hidden lg:block" />{' '}
          teacher every class, every week.
        </h2>

        <div className="mt-12 grid items-start gap-10 lg:grid-cols-[380px_1fr] lg:gap-14">
          <div className="mx-auto w-full max-w-sm lg:mx-0">
            <div className="aspect-square overflow-hidden rounded-2xl shadow-lg ring-1 ring-slate-200">
              <Image
                src="/instructor-photos/abraham.jpg"
                alt="Abraham — lead instructor at Mind Mirth"
                className="h-full w-full object-cover"
                priority
              />
            </div>
          </div>

          <div>
            <h3 className="text-2xl font-semibold text-slate-900 sm:text-3xl">
              Abraham
            </h3>
            <p className="mt-1 text-base text-slate-500">
              Lead instructor &amp; founder, Mind Mirth
            </p>

            <p className="mt-6 text-base leading-relaxed text-slate-600">
              Abraham has spent 15+ years teaching math &mdash; leading small bootcamps
              and private classes for families who wanted more than a tutoring chain
              could offer. He teaches every single session himself; you&rsquo;ll never get
              handed off to a college student or rotating staff.
            </p>

            <p className="mt-4 text-base leading-relaxed text-slate-600">
              His students arrive nervous about math and leave asking for harder
              problems. That&rsquo;s the whole job.
            </p>

            <div className="mt-8 grid grid-cols-2 gap-x-8 gap-y-3">
              {TEACHER_STATS.map((stat) => {
                const Icon = stat.icon;
                return (
                  <div key={stat.text} className="flex items-center gap-2.5">
                    <Icon className="size-4 shrink-0 text-brand-600" aria-hidden="true" />
                    <span className="text-sm font-medium text-slate-700">{stat.text}</span>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}